// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OverviewWidgets_filterPanel__ldix1,
.OverviewWidgets_mapCard__88ub8,
.OverviewWidgets_servicesPanel__RpIsR,
.OverviewWidgets_sideCard__VvP5Z {
  background: #fff;
  border: 1px solid #dce3e8;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(30, 55, 75, 0.06);
}

.OverviewWidgets_filterPanel__ldix1 {
  padding: 16px;
}

.OverviewWidgets_filterPanel__ldix1 h2,
.OverviewWidgets_sideCard__VvP5Z h2 {
  margin: 0 0 14px;
  font-size: 1rem;
}

.OverviewWidgets_filterItem__TfLOP {
  display: flex;
  gap: 8px;
  align-items: center;
  margin: 12px 0;
  font-size: 0.92rem;
}

.OverviewWidgets_filterItem__TfLOP img {
  width: 18px;
  height: 18px;
  object-fit: contain;
}

.OverviewWidgets_mapCard__88ub8 {
  padding: 12px;
}

.OverviewWidgets_mapHeader__g1tKS {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.OverviewWidgets_mapHeader__g1tKS strong {
  color: #155aa8;
  border-bottom: 3px solid #155aa8;
  padding-bottom: 5px;
}

.OverviewWidgets_mapPlaceholder__PUURO {
  min-height: 270px;
  background: #edf6ff;
  border: 2px dashed #b7cfe7;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #54718c;
}

.OverviewWidgets_servicesPanel__RpIsR {
  overflow: hidden;
}

.OverviewWidgets_servicesTabs__Bxe6o {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  min-height: 48px;
  padding: 0 14px;
  border-bottom: 1px solid #dce3e8;
  overflow-x: auto;
}

.OverviewWidgets_servicesTabs__Bxe6o button {
  flex: 0 0 auto;
  appearance: none;
  border: 0;
  border-bottom: 3px solid transparent;
  padding: 14px 12px 10px;
  background: transparent;
  color: #607080;
  font: inherit;
  font-size: 0.86rem;
  cursor: pointer;
}

.OverviewWidgets_servicesTabs__Bxe6o button:hover,
.OverviewWidgets_servicesTabs__Bxe6o button:focus-visible {
  color: #173f56;
  outline: none;
}

.OverviewWidgets_servicesTabs__Bxe6o .OverviewWidgets_activeServicesTab__cPIml {
  border-bottom-color: #173f56;
  color: #173f56;
  font-weight: 700;
}

.OverviewWidgets_tableWrapper__ANpyO {
  overflow-x: auto;
  padding: 14px;
}

.OverviewWidgets_servicesTable__KFeyB {
  width: 100%;
  min-width: 720px;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 0.84rem;
}

.OverviewWidgets_servicesTable__KFeyB thead th {
  height: 48px;
  padding: 8px 10px;
  background: #f2f2f2;
  color: #253743;
  text-align: left;
  font-weight: 600;
}

.OverviewWidgets_servicesTable__KFeyB thead th:first-child {
  border-radius: 14px 0 0 14px;
}

.OverviewWidgets_servicesTable__KFeyB thead th:last-child {
  border-radius: 0 14px 14px 0;
}

.OverviewWidgets_servicesTable__KFeyB tbody td {
  height: 52px;
  padding: 8px 10px;
  border-bottom: 1px solid #edf0f2;
  vertical-align: middle;
}

.OverviewWidgets_servicesTable__KFeyB tbody tr {
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.OverviewWidgets_servicesTable__KFeyB tbody tr:hover,
.OverviewWidgets_servicesTable__KFeyB tbody tr.OverviewWidgets_selectedRow__MX4HQ {
  background: #f3f8fc;
}

.OverviewWidgets_serviceNameCell__flAYg {
  min-width: 190px;
  color: #162d3b;
  font-weight: 500;
}

.OverviewWidgets_compactValueHeader__fdxly {
  width: 64px;
  text-align: center !important;
}

.OverviewWidgets_valueIconBox__cuDKn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: 1px solid currentColor;
  border-radius: 7px;
  background: #fff;
  transition: box-shadow 0.15s ease, transform 0.15s ease;
}

.OverviewWidgets_valueIconBox__cuDKn img {
  width: 20px;
  height: 20px;
}

.OverviewWidgets_valueIconBox__cuDKn.OverviewWidgets_bienveillance__cT8p1 {
  color: var(--upcare-value-bienveillance);
  background: var(--upcare-value-bienveillance-soft);
}

.OverviewWidgets_valueIconBox__cuDKn.OverviewWidgets_engagement__BjCAN {
  color: var(--upcare-value-engagement);
  background: var(--upcare-value-engagement-soft);
}

.OverviewWidgets_valueIconBox__cuDKn.OverviewWidgets_faireEquipe__JZfYu {
  color: var(--upcare-value-faire-equipe);
  background: var(--upcare-value-faire-equipe-soft);
}

.OverviewWidgets_valueIconBox__cuDKn.OverviewWidgets_respect__IGf5\\+ {
  color: var(--upcare-value-respect);
  background: var(--upcare-value-respect-soft);
}

.OverviewWidgets_selectedValueHeader__eSdMi {
  box-shadow: 0 0 0 2px rgba(23, 63, 86, 0.18);
  transform: translateY(-1px);
}

.OverviewWidgets_valueScoreCell__sESCQ {
  width: 72px;
}

.OverviewWidgets_compactScore__lyCBg {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  width: 42px;
  padding: 2px 3px;
  border-radius: 5px;
}

.OverviewWidgets_activeCompactScore__6qpSQ {
  background: rgba(23, 63, 86, 0.04);
}

.OverviewWidgets_compactScoreValue__4FYqV {
  color: #243746;
  font-size: 0.86rem;
  font-variant-numeric: tabular-nums;
}

.OverviewWidgets_compactScoreTrack__M2nZv {
  display: block;
  width: 34px;
  height: 4px;
  overflow: hidden;
  border-radius: 999px;
  background: var(--upcare-value-track);
}

.OverviewWidgets_compactScoreTrack__M2nZv span {
  display: block;
  height: 100%;
  border-radius: inherit;
}

.OverviewWidgets_bienveillance__cT8p1 .OverviewWidgets_compactScoreTrack__M2nZv span,
.OverviewWidgets_compactScore__lyCBg.OverviewWidgets_bienveillance__cT8p1 .OverviewWidgets_compactScoreTrack__M2nZv span {
  background: var(--upcare-value-bienveillance);
}

.OverviewWidgets_engagement__BjCAN .OverviewWidgets_compactScoreTrack__M2nZv span,
.OverviewWidgets_compactScore__lyCBg.OverviewWidgets_engagement__BjCAN .OverviewWidgets_compactScoreTrack__M2nZv span {
  background: var(--upcare-value-engagement);
}

.OverviewWidgets_faireEquipe__JZfYu .OverviewWidgets_compactScoreTrack__M2nZv span,
.OverviewWidgets_compactScore__lyCBg.OverviewWidgets_faireEquipe__JZfYu .OverviewWidgets_compactScoreTrack__M2nZv span {
  background: var(--upcare-value-faire-equipe);
}

.OverviewWidgets_respect__IGf5\\+ .OverviewWidgets_compactScoreTrack__M2nZv span,
.OverviewWidgets_compactScore__lyCBg.OverviewWidgets_respect__IGf5\\+ .OverviewWidgets_compactScoreTrack__M2nZv span {
  background: var(--upcare-value-respect);
}

.OverviewWidgets_evolutionHeader__PAxKU {
  min-width: 110px;
  text-align: center !important;
}

.OverviewWidgets_evolutionValue__-gkQX,
.OverviewWidgets_evolutionNoData__-apek {
  display: block;
  text-align: center;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.OverviewWidgets_evolution_up__-qpHn {
  color: #2a9d55;
}

.OverviewWidgets_evolution_down__-vhHA {
  color: #e33a46;
}

.OverviewWidgets_evolution_stable__CeyMp,
.OverviewWidgets_evolutionNoData__-apek {
  color: #7a8790;
}

.OverviewWidgets_averageHeader__XB6e4 {
  min-width: 130px;
  text-align: right !important;
}

.OverviewWidgets_averageScore__wf3os {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

.OverviewWidgets_averageTrack__\\+1J4Q {
  display: block;
  width: 80px;
  height: 6px;
  overflow: hidden;
  border-radius: 999px;
  background: #edf0f4;
}

.OverviewWidgets_averageTrack__\\+1J4Q span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #8db9f3, #286ac5);
}

.OverviewWidgets_averageScore__wf3os strong {
  min-width: 24px;
  color: #88a9dd;
  text-align: right;
  font-size: 0.9rem;
  font-variant-numeric: tabular-nums;
}

.OverviewWidgets_tabPlaceholder__6umqy {
  min-height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  color: #71808b;
  text-align: center;
  font-size: 0.88rem;
}

.OverviewWidgets_sideCard__VvP5Z {
  padding: 14px;
}

.OverviewWidgets_contextLabel__8ncWQ {
  margin: -7px 0 14px;
  color: #687681;
  font-size: 0.76rem;
}

.OverviewWidgets_scoreHint__ol1nT {
  margin: -8px 0 12px;
  color: #7b8a95;
  font-size: 0.7rem;
}

.OverviewWidgets_emptyText__JzjG8 {
  min-height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #687681;
  font-size: 0.88rem;
}

.OverviewWidgets_scoreGrid__P6Le4 {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px 14px;
}

.OverviewWidgets_scoreTile__W-pTP {
  min-width: 0;
  padding: 8px;
  border: 2px solid transparent;
  border-radius: 10px;
  transition: background-color 0.2s, border-color 0.2s, box-shadow 0.15s, transform 0.15s;
}

.OverviewWidgets_clickableScore__AtA3h {
  cursor: pointer;
}

.OverviewWidgets_clickableScore__AtA3h:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(31, 54, 72, 0.08);
}

.OverviewWidgets_clickableScore__AtA3h:focus-visible {
  outline: 2px solid #2c6b88;
  outline-offset: 2px;
}

.OverviewWidgets_scoreTile__W-pTP.OverviewWidgets_activeScore__JVuNn.OverviewWidgets_bienveillance__cT8p1 {
  border-color: var(--upcare-value-bienveillance);
  background: var(--upcare-value-bienveillance-soft);
}

.OverviewWidgets_scoreTile__W-pTP.OverviewWidgets_activeScore__JVuNn.OverviewWidgets_engagement__BjCAN {
  border-color: var(--upcare-value-engagement);
  background: var(--upcare-value-engagement-soft);
}

.OverviewWidgets_scoreTile__W-pTP.OverviewWidgets_activeScore__JVuNn.OverviewWidgets_faireEquipe__JZfYu {
  border-color: var(--upcare-value-faire-equipe);
  background: var(--upcare-value-faire-equipe-soft);
}

.OverviewWidgets_scoreTile__W-pTP.OverviewWidgets_activeScore__JVuNn.OverviewWidgets_respect__IGf5\\+ {
  border-color: var(--upcare-value-respect);
  background: var(--upcare-value-respect-soft);
}

.OverviewWidgets_scoreValue__IUcT3 {
  display: flex;
  align-items: baseline;
  gap: 3px;
  color: var(--upcare-value-text);
}

.OverviewWidgets_scoreValue__IUcT3 strong {
  font-size: 2rem;
  line-height: 1;
  font-weight: 500;
}

.OverviewWidgets_scoreValue__IUcT3 span {
  font-size: 0.85rem;
}

.OverviewWidgets_progress__mAuKW {
  height: 10px;
  background: var(--upcare-value-track);
  border-radius: 3px;
  margin-top: 8px;
  overflow: hidden;
}

.OverviewWidgets_progress__mAuKW span {
  display: block;
  height: 100%;
  border-radius: 3px;
}

.OverviewWidgets_bienveillance__cT8p1 .OverviewWidgets_progress__mAuKW span {
  background: var(--upcare-value-bienveillance);
}

.OverviewWidgets_engagement__BjCAN .OverviewWidgets_progress__mAuKW span {
  background: var(--upcare-value-engagement);
}

.OverviewWidgets_faireEquipe__JZfYu .OverviewWidgets_progress__mAuKW span {
  background: var(--upcare-value-faire-equipe);
}

.OverviewWidgets_respect__IGf5\\+ .OverviewWidgets_progress__mAuKW span {
  background: var(--upcare-value-respect);
}

.OverviewWidgets_scoreName__MCG2J {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-top: 9px;
  color: #1f2d37;
  font-size: 0.76rem;
  line-height: 1.15;
}

.OverviewWidgets_scoreName__MCG2J img {
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
}

.OverviewWidgets_suggestions__pD4-w {
  background: #e6f2ff;
}

.OverviewWidgets_suggestionTitle__d1Gsp {
  display: block;
  margin-bottom: 7px;
  font-size: 0.88rem;
}

.OverviewWidgets_suggestionText__vBBKw {
  margin: 0 0 10px;
  color: #536675;
  font-size: 0.8rem;
  line-height: 1.35;
}

.OverviewWidgets_suggestions__pD4-w button {
  width: 100%;
  display: block;
  margin: 7px 0;
  padding: 8px;
  border: 1px solid #9eb9cd;
  border-radius: 6px;
  background: white;
  text-align: left;
  cursor: pointer;
}

@media (max-width: 760px) {
  .OverviewWidgets_servicesTabs__Bxe6o {
    padding: 0 8px;
  }

  .OverviewWidgets_tableWrapper__ANpyO {
    padding: 10px;
  }
}

@media (max-width: 420px) {
  .OverviewWidgets_scoreGrid__P6Le4 {
    grid-template-columns: 1fr;
  }

  .OverviewWidgets_scoreValue__IUcT3 strong {
    font-size: 1.7rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Overview/OverviewWidgets.module.css"],"names":[],"mappings":"AAAA;;;;EAIE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,uCAAuC;AACzC;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,uDAAuD;AACzD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,kDAAkD;AACpD;;AAEA;EACE,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;EACE,uCAAuC;EACvC,iDAAiD;AACnD;;AAEA;EACE,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;AACxB;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,oDAAoD;AACtD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,uFAAuF;AACzF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;EAC/C,kDAAkD;AACpD;;AAEA;EACE,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,8CAA8C;EAC9C,iDAAiD;AACnD;;AAEA;EACE,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".filterPanel,\n.mapCard,\n.servicesPanel,\n.sideCard {\n  background: #fff;\n  border: 1px solid #dce3e8;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(30, 55, 75, 0.06);\n}\n\n.filterPanel {\n  padding: 16px;\n}\n\n.filterPanel h2,\n.sideCard h2 {\n  margin: 0 0 14px;\n  font-size: 1rem;\n}\n\n.filterItem {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  margin: 12px 0;\n  font-size: 0.92rem;\n}\n\n.filterItem img {\n  width: 18px;\n  height: 18px;\n  object-fit: contain;\n}\n\n.mapCard {\n  padding: 12px;\n}\n\n.mapHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.mapHeader strong {\n  color: #155aa8;\n  border-bottom: 3px solid #155aa8;\n  padding-bottom: 5px;\n}\n\n.mapPlaceholder {\n  min-height: 270px;\n  background: #edf6ff;\n  border: 2px dashed #b7cfe7;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  color: #54718c;\n}\n\n.servicesPanel {\n  overflow: hidden;\n}\n\n.servicesTabs {\n  display: flex;\n  align-items: flex-end;\n  gap: 8px;\n  min-height: 48px;\n  padding: 0 14px;\n  border-bottom: 1px solid #dce3e8;\n  overflow-x: auto;\n}\n\n.servicesTabs button {\n  flex: 0 0 auto;\n  appearance: none;\n  border: 0;\n  border-bottom: 3px solid transparent;\n  padding: 14px 12px 10px;\n  background: transparent;\n  color: #607080;\n  font: inherit;\n  font-size: 0.86rem;\n  cursor: pointer;\n}\n\n.servicesTabs button:hover,\n.servicesTabs button:focus-visible {\n  color: #173f56;\n  outline: none;\n}\n\n.servicesTabs .activeServicesTab {\n  border-bottom-color: #173f56;\n  color: #173f56;\n  font-weight: 700;\n}\n\n.tableWrapper {\n  overflow-x: auto;\n  padding: 14px;\n}\n\n.servicesTable {\n  width: 100%;\n  min-width: 720px;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 0.84rem;\n}\n\n.servicesTable thead th {\n  height: 48px;\n  padding: 8px 10px;\n  background: #f2f2f2;\n  color: #253743;\n  text-align: left;\n  font-weight: 600;\n}\n\n.servicesTable thead th:first-child {\n  border-radius: 14px 0 0 14px;\n}\n\n.servicesTable thead th:last-child {\n  border-radius: 0 14px 14px 0;\n}\n\n.servicesTable tbody td {\n  height: 52px;\n  padding: 8px 10px;\n  border-bottom: 1px solid #edf0f2;\n  vertical-align: middle;\n}\n\n.servicesTable tbody tr {\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.servicesTable tbody tr:hover,\n.servicesTable tbody tr.selectedRow {\n  background: #f3f8fc;\n}\n\n.serviceNameCell {\n  min-width: 190px;\n  color: #162d3b;\n  font-weight: 500;\n}\n\n.compactValueHeader {\n  width: 64px;\n  text-align: center !important;\n}\n\n.valueIconBox {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border: 1px solid currentColor;\n  border-radius: 7px;\n  background: #fff;\n  transition: box-shadow 0.15s ease, transform 0.15s ease;\n}\n\n.valueIconBox img {\n  width: 20px;\n  height: 20px;\n}\n\n.valueIconBox.bienveillance {\n  color: var(--upcare-value-bienveillance);\n  background: var(--upcare-value-bienveillance-soft);\n}\n\n.valueIconBox.engagement {\n  color: var(--upcare-value-engagement);\n  background: var(--upcare-value-engagement-soft);\n}\n\n.valueIconBox.faireEquipe {\n  color: var(--upcare-value-faire-equipe);\n  background: var(--upcare-value-faire-equipe-soft);\n}\n\n.valueIconBox.respect {\n  color: var(--upcare-value-respect);\n  background: var(--upcare-value-respect-soft);\n}\n\n.selectedValueHeader {\n  box-shadow: 0 0 0 2px rgba(23, 63, 86, 0.18);\n  transform: translateY(-1px);\n}\n\n.valueScoreCell {\n  width: 72px;\n}\n\n.compactScore {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  width: 42px;\n  padding: 2px 3px;\n  border-radius: 5px;\n}\n\n.activeCompactScore {\n  background: rgba(23, 63, 86, 0.04);\n}\n\n.compactScoreValue {\n  color: #243746;\n  font-size: 0.86rem;\n  font-variant-numeric: tabular-nums;\n}\n\n.compactScoreTrack {\n  display: block;\n  width: 34px;\n  height: 4px;\n  overflow: hidden;\n  border-radius: 999px;\n  background: var(--upcare-value-track);\n}\n\n.compactScoreTrack span {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n}\n\n.bienveillance .compactScoreTrack span,\n.compactScore.bienveillance .compactScoreTrack span {\n  background: var(--upcare-value-bienveillance);\n}\n\n.engagement .compactScoreTrack span,\n.compactScore.engagement .compactScoreTrack span {\n  background: var(--upcare-value-engagement);\n}\n\n.faireEquipe .compactScoreTrack span,\n.compactScore.faireEquipe .compactScoreTrack span {\n  background: var(--upcare-value-faire-equipe);\n}\n\n.respect .compactScoreTrack span,\n.compactScore.respect .compactScoreTrack span {\n  background: var(--upcare-value-respect);\n}\n\n.evolutionHeader {\n  min-width: 110px;\n  text-align: center !important;\n}\n\n.evolutionValue,\n.evolutionNoData {\n  display: block;\n  text-align: center;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n}\n\n.evolution_up {\n  color: #2a9d55;\n}\n\n.evolution_down {\n  color: #e33a46;\n}\n\n.evolution_stable,\n.evolutionNoData {\n  color: #7a8790;\n}\n\n.averageHeader {\n  min-width: 130px;\n  text-align: right !important;\n}\n\n.averageScore {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.averageTrack {\n  display: block;\n  width: 80px;\n  height: 6px;\n  overflow: hidden;\n  border-radius: 999px;\n  background: #edf0f4;\n}\n\n.averageTrack span {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n  background: linear-gradient(90deg, #8db9f3, #286ac5);\n}\n\n.averageScore strong {\n  min-width: 24px;\n  color: #88a9dd;\n  text-align: right;\n  font-size: 0.9rem;\n  font-variant-numeric: tabular-nums;\n}\n\n.tabPlaceholder {\n  min-height: 150px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  color: #71808b;\n  text-align: center;\n  font-size: 0.88rem;\n}\n\n.sideCard {\n  padding: 14px;\n}\n\n.contextLabel {\n  margin: -7px 0 14px;\n  color: #687681;\n  font-size: 0.76rem;\n}\n\n.scoreHint {\n  margin: -8px 0 12px;\n  color: #7b8a95;\n  font-size: 0.7rem;\n}\n\n.emptyText {\n  min-height: 70px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  color: #687681;\n  font-size: 0.88rem;\n}\n\n.scoreGrid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px 14px;\n}\n\n.scoreTile {\n  min-width: 0;\n  padding: 8px;\n  border: 2px solid transparent;\n  border-radius: 10px;\n  transition: background-color 0.2s, border-color 0.2s, box-shadow 0.15s, transform 0.15s;\n}\n\n.clickableScore {\n  cursor: pointer;\n}\n\n.clickableScore:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 10px rgba(31, 54, 72, 0.08);\n}\n\n.clickableScore:focus-visible {\n  outline: 2px solid #2c6b88;\n  outline-offset: 2px;\n}\n\n.scoreTile.activeScore.bienveillance {\n  border-color: var(--upcare-value-bienveillance);\n  background: var(--upcare-value-bienveillance-soft);\n}\n\n.scoreTile.activeScore.engagement {\n  border-color: var(--upcare-value-engagement);\n  background: var(--upcare-value-engagement-soft);\n}\n\n.scoreTile.activeScore.faireEquipe {\n  border-color: var(--upcare-value-faire-equipe);\n  background: var(--upcare-value-faire-equipe-soft);\n}\n\n.scoreTile.activeScore.respect {\n  border-color: var(--upcare-value-respect);\n  background: var(--upcare-value-respect-soft);\n}\n\n.scoreValue {\n  display: flex;\n  align-items: baseline;\n  gap: 3px;\n  color: var(--upcare-value-text);\n}\n\n.scoreValue strong {\n  font-size: 2rem;\n  line-height: 1;\n  font-weight: 500;\n}\n\n.scoreValue span {\n  font-size: 0.85rem;\n}\n\n.progress {\n  height: 10px;\n  background: var(--upcare-value-track);\n  border-radius: 3px;\n  margin-top: 8px;\n  overflow: hidden;\n}\n\n.progress span {\n  display: block;\n  height: 100%;\n  border-radius: 3px;\n}\n\n.bienveillance .progress span {\n  background: var(--upcare-value-bienveillance);\n}\n\n.engagement .progress span {\n  background: var(--upcare-value-engagement);\n}\n\n.faireEquipe .progress span {\n  background: var(--upcare-value-faire-equipe);\n}\n\n.respect .progress span {\n  background: var(--upcare-value-respect);\n}\n\n.scoreName {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  margin-top: 9px;\n  color: #1f2d37;\n  font-size: 0.76rem;\n  line-height: 1.15;\n}\n\n.scoreName img {\n  width: 18px;\n  height: 18px;\n  flex: 0 0 18px;\n}\n\n.suggestions {\n  background: #e6f2ff;\n}\n\n.suggestionTitle {\n  display: block;\n  margin-bottom: 7px;\n  font-size: 0.88rem;\n}\n\n.suggestionText {\n  margin: 0 0 10px;\n  color: #536675;\n  font-size: 0.8rem;\n  line-height: 1.35;\n}\n\n.suggestions button {\n  width: 100%;\n  display: block;\n  margin: 7px 0;\n  padding: 8px;\n  border: 1px solid #9eb9cd;\n  border-radius: 6px;\n  background: white;\n  text-align: left;\n  cursor: pointer;\n}\n\n@media (max-width: 760px) {\n  .servicesTabs {\n    padding: 0 8px;\n  }\n\n  .tableWrapper {\n    padding: 10px;\n  }\n}\n\n@media (max-width: 420px) {\n  .scoreGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .scoreValue strong {\n    font-size: 1.7rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filterPanel": `OverviewWidgets_filterPanel__ldix1`,
	"mapCard": `OverviewWidgets_mapCard__88ub8`,
	"servicesPanel": `OverviewWidgets_servicesPanel__RpIsR`,
	"sideCard": `OverviewWidgets_sideCard__VvP5Z`,
	"filterItem": `OverviewWidgets_filterItem__TfLOP`,
	"mapHeader": `OverviewWidgets_mapHeader__g1tKS`,
	"mapPlaceholder": `OverviewWidgets_mapPlaceholder__PUURO`,
	"servicesTabs": `OverviewWidgets_servicesTabs__Bxe6o`,
	"activeServicesTab": `OverviewWidgets_activeServicesTab__cPIml`,
	"tableWrapper": `OverviewWidgets_tableWrapper__ANpyO`,
	"servicesTable": `OverviewWidgets_servicesTable__KFeyB`,
	"selectedRow": `OverviewWidgets_selectedRow__MX4HQ`,
	"serviceNameCell": `OverviewWidgets_serviceNameCell__flAYg`,
	"compactValueHeader": `OverviewWidgets_compactValueHeader__fdxly`,
	"valueIconBox": `OverviewWidgets_valueIconBox__cuDKn`,
	"bienveillance": `OverviewWidgets_bienveillance__cT8p1`,
	"engagement": `OverviewWidgets_engagement__BjCAN`,
	"faireEquipe": `OverviewWidgets_faireEquipe__JZfYu`,
	"respect": `OverviewWidgets_respect__IGf5+`,
	"selectedValueHeader": `OverviewWidgets_selectedValueHeader__eSdMi`,
	"valueScoreCell": `OverviewWidgets_valueScoreCell__sESCQ`,
	"compactScore": `OverviewWidgets_compactScore__lyCBg`,
	"activeCompactScore": `OverviewWidgets_activeCompactScore__6qpSQ`,
	"compactScoreValue": `OverviewWidgets_compactScoreValue__4FYqV`,
	"compactScoreTrack": `OverviewWidgets_compactScoreTrack__M2nZv`,
	"evolutionHeader": `OverviewWidgets_evolutionHeader__PAxKU`,
	"evolutionValue": `OverviewWidgets_evolutionValue__-gkQX`,
	"evolutionNoData": `OverviewWidgets_evolutionNoData__-apek`,
	"evolution_up": `OverviewWidgets_evolution_up__-qpHn`,
	"evolution_down": `OverviewWidgets_evolution_down__-vhHA`,
	"evolution_stable": `OverviewWidgets_evolution_stable__CeyMp`,
	"averageHeader": `OverviewWidgets_averageHeader__XB6e4`,
	"averageScore": `OverviewWidgets_averageScore__wf3os`,
	"averageTrack": `OverviewWidgets_averageTrack__+1J4Q`,
	"tabPlaceholder": `OverviewWidgets_tabPlaceholder__6umqy`,
	"contextLabel": `OverviewWidgets_contextLabel__8ncWQ`,
	"scoreHint": `OverviewWidgets_scoreHint__ol1nT`,
	"emptyText": `OverviewWidgets_emptyText__JzjG8`,
	"scoreGrid": `OverviewWidgets_scoreGrid__P6Le4`,
	"scoreTile": `OverviewWidgets_scoreTile__W-pTP`,
	"clickableScore": `OverviewWidgets_clickableScore__AtA3h`,
	"activeScore": `OverviewWidgets_activeScore__JVuNn`,
	"scoreValue": `OverviewWidgets_scoreValue__IUcT3`,
	"progress": `OverviewWidgets_progress__mAuKW`,
	"scoreName": `OverviewWidgets_scoreName__MCG2J`,
	"suggestions": `OverviewWidgets_suggestions__pD4-w`,
	"suggestionTitle": `OverviewWidgets_suggestionTitle__d1Gsp`,
	"suggestionText": `OverviewWidgets_suggestionText__vBBKw`
};
export default ___CSS_LOADER_EXPORT___;
